import { normalizePosSlotLayouts } from './posSlotLayouts';

const USER_PREFERENCES_UPDATED_EVENT = 'user-preferences-updated';
const USER_PREFERENCES_STORAGE_KEY = 'userPreferencesBroadcast';

const normalizeStringList = (value) => (
  Array.isArray(value)
    ? value.map((item) => String(item || '').trim()).filter((item) => item)
    : []
);

export const normalizeUserPreferences = (value) => ({
  userId: Number.isInteger(Number(value?.userId)) ? Number(value.userId) : null,
  homeShortcuts: normalizeStringList(value?.homeShortcuts),
  posSlotLayouts: normalizePosSlotLayouts(value?.posSlotLayouts),
});

export const normalizeUserPreferencesUpdate = (value = {}) => {
  const updates = {};
  if (Object.prototype.hasOwnProperty.call(value, 'homeShortcuts')) {
    updates.homeShortcuts = normalizeStringList(value?.homeShortcuts);
  }
  if (Object.prototype.hasOwnProperty.call(value, 'posSlotLayouts')) {
    updates.posSlotLayouts = normalizePosSlotLayouts(value?.posSlotLayouts);
  }
  return updates;
};

export const broadcastUserPreferencesUpdated = (preferences) => {
  if (typeof window === 'undefined') return;
  const normalized = normalizeUserPreferences(preferences);
  window.dispatchEvent(new CustomEvent(USER_PREFERENCES_UPDATED_EVENT, {
    detail: normalized,
  }));
  try {
    window.localStorage.setItem(USER_PREFERENCES_STORAGE_KEY, JSON.stringify({
      updatedAt: Date.now(),
      preferences: normalized,
    }));
  } catch (error) {
    // Ignore storage write failures.
  }
};

export const subscribeUserPreferencesUpdates = (listener) => {
  if (typeof window === 'undefined' || typeof listener !== 'function') {
    return () => {};
  }

  const handleEvent = (event) => {
    listener(normalizeUserPreferences(event?.detail));
  };

  const handleStorage = (event) => {
    if (event.key !== USER_PREFERENCES_STORAGE_KEY || !event.newValue) return;
    try {
      const payload = JSON.parse(event.newValue);
      listener(normalizeUserPreferences(payload?.preferences));
    } catch (error) {
      // Ignore malformed storage payloads.
    }
  };

  window.addEventListener(USER_PREFERENCES_UPDATED_EVENT, handleEvent);
  window.addEventListener('storage', handleStorage);
  return () => {
    window.removeEventListener(USER_PREFERENCES_UPDATED_EVENT, handleEvent);
    window.removeEventListener('storage', handleStorage);
  };
};
